<template>
  <app-shell>
    <vnt-header>Add item</vnt-header>
    <item-form />
  </app-shell>
</template>

<script>
import AppShell from '@/components/AppShell.vue'
import ItemForm from '@/components/items/ItemForm.vue'

export default {
  name: 'ItemFormView',

  components: {
    AppShell,
    ItemForm
  }
}
</script>
